import { render, staticRenderFns } from "./EditCSOClient.vue?vue&type=template&id=44dad724"
import script from "./EditCSOClient.vue?vue&type=script&lang=js"
export * from "./EditCSOClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports